import React from 'react'
import BusinessCardOrderForm from './feature/BusinessCardOrderForm'
import { tabsItems } from './constants/tabsItems.constant'
import { useTranslation } from 'react-i18next'
import { useBusinessCardQhtStatusQuery } from '@app/store/reducers/salaryCards/businessCardOrder.api'
import ContentBoxNew from '@shared/ContentBoxNew'

function CreateBusinessCardOrder() {
  const { t } = useTranslation()
  const { isError, isSuccess, isFetching, isLoading, error } =
    useBusinessCardQhtStatusQuery({ status: 'frozen', page: 'create' })

  const shouldRenderChildren =
    isSuccess && !isFetching && !isLoading && !isError

  return (
    <ContentBoxNew
      isError={isError && !isSuccess}
      isLoading={isFetching || isLoading}
      errorMessage={error?.data}
      title={t('businessCardOrders.businessCardOrders')}
      activeKey="item-2"
      items={tabsItems()}
      shouldRenderChildren={shouldRenderChildren}
    >
      <BusinessCardOrderForm />
    </ContentBoxNew>
  )
}

export default CreateBusinessCardOrder
